"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elevation = {
    0: {
        boxShadow: 'none',
    },
    1: {
        boxShadow: '0 6px 16px -5px rgba(0, 0, 0, 0.2)',
    },
    2: {
        boxShadow: '0 12px 32px -9px rgba(0, 0, 0, 0.2)',
    },
    3: {
        boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.14),\n                0 1px 18px 0 rgba(0, 0, 0, 0.12),\n                0 3px 5px -1px rgba(0, 0, 0, 0.4)",
    },
    4: {
        boxShadow: "0 8px 10px 1px rgba(0, 0, 0, 0.14),\n                0 3px 14px 2px rgba(0, 0, 0, 0.12),\n                0 5px 5px -3px rgba(0, 0, 0, 0.4)",
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/components/styles/elevation.ts
// module id = 278
// module chunks = 0